import { useCallback } from 'react';

import OrderCreatedToaster from '~components/Toasters/OrderCreatedToaster';
import { Order } from '~hooks/useOrders/models';
import { useStores } from '~store';
import { alert, AlertTypes } from '~types/AlertTypes';

export default function useOrderCreatedToaster() {
  const { ordersDispatchStore, toasterStore } = useStores();

  const showOrderCreatedToaster = useCallback(
    (order: Order) => {
      toasterStore.push(
        alert(<OrderCreatedToaster order={order} />, AlertTypes.success, null, () => {
          ordersDispatchStore.setDeepLinkedOrder(order, { source: 'created' });
        }),
        true,
      );
    },
    [ordersDispatchStore, toasterStore],
  );

  return { showOrderCreatedToaster };
}
